'use client';
import React, { useEffect, useMemo, useRef } from 'react';
import { CSSRulePlugin } from 'gsap/dist/CSSRulePlugin';
import { useInView } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { useShowSetting } from '@/core/context/ShowSettingProvider';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
// eslint-disable-next-line react/display-name
const AboutSVG = React.memo(({ svgsRef }) => (
	<svg
		ref={svgsRef}
		width="905"
		height="435"
		viewBox="0 0 905 435"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M82.4848 241.184C29.23 165.243 0.76006 74.693 0.976054 -18.0593L151.551 -17.9117C151.535 -9.13663 151.902 -0.356596 152.651 8.42842C157.251 61.0813 175.612 111.6 205.892 154.92C236.172 198.24 277.307 232.839 325.175 255.249C419.419 299.188 533.878 293.073 625.235 229.216C664.932 201.511 697.356 164.634 719.751 121.717C742.146 78.8004 753.852 31.1121 753.873 -17.2966L904.453 -17.1438C904.426 0.73094 903.336 18.5882 901.188 36.3335C886.35 159.455 821.146 275.987 711.499 352.629C601.853 429.27 470.021 450.463 349.288 422.104C241.066 396.809 146.03 332.365 82.4848 241.184Z"
			fill="url(#paint0_linear_506_6583)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_506_6583"
				x1="402.875"
				y1="361.06"
				x2="214.677"
				y2="185.486"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>
));

// eslint-disable-next-line react/display-name
const FooterSVG = React.memo(({ svgsRef }) => (
	<svg
		ref={svgsRef}
		width="392"
		height="514"
		viewBox="0 0 392 514"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			opacity="0.1"
			d="M195.801 434.072C119.421 486.694 28.6371 514.411 -64.1102 513.425L-62.7123 362.857C-53.9377 362.945 -45.1549 362.651 -36.364 361.975C16.3253 357.812 66.9945 339.872 110.564 309.953C154.134 280.033 189.074 239.187 211.88 191.507C256.601 97.6304 251.437 -16.875 188.34 -108.76C160.966 -148.685 124.359 -181.414 81.6297 -204.165C38.9004 -226.915 -8.68907 -239.016 -57.0959 -239.44L-55.6928 -390.013C-37.8189 -389.838 -19.9712 -388.599 -2.2444 -386.304C120.749 -370.445 236.736 -304.275 312.465 -193.996C388.193 -83.7166 408.291 48.2868 378.93 168.78C352.737 276.788 287.506 371.286 195.801 434.072Z"
			fill="url(#paint0_linear_509_7964)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_509_7964"
				x1="318.333"
				y1="114.688"
				x2="141.203"
				y2="301.422"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>
));
// eslint-disable-next-line react/display-name
const ProductSVG = React.memo(({ svgsRef }) => (
	<svg
		ref={svgsRef}
		width="445"
		height="598"
		viewBox="0 0 445 598"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			opacity="0.2"
			d="M246.419 519.642C169.707 571.778 78.7493 598.919 -13.99 597.344L-11.6367 446.788C-2.86281 446.932 5.92165 446.694 14.7167 446.074C67.4313 442.245 118.213 424.627 161.972 394.984C205.731 365.342 240.929 324.718 264.038 277.184C309.353 183.593 304.915 69.057 242.403 -23.2261C215.283 -63.3247 178.884 -96.2847 136.3 -119.306C93.7162 -142.328 46.2045 -154.73 -2.19862 -155.461L0.159867 -306.022C18.0323 -305.733 35.8717 -304.382 53.5836 -301.975C176.474 -285.335 292.039 -218.431 367.066 -107.673C442.093 3.08453 461.353 135.213 431.228 255.517C404.35 363.357 338.521 457.439 246.419 519.642Z"
			fill="url(#paint0_linear_507_7794)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_507_7794"
				x1="370.976"
				y1="201.042"
				x2="192.664"
				y2="386.648"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#152637" stopOpacity="0" />
				<stop offset="1" stopColor="#152637" />
			</linearGradient>
		</defs>
	</svg>
));
// eslint-disable-next-line react/display-name
const CareerSVG = React.memo(({ svgsRef }) => (
	<svg width="445" height="598" viewBox="0 0 445 598" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.2" d="M246.421 519.642C169.709 571.778 78.7512 598.919 -13.988 597.344L-11.6347 446.788C-2.86085 446.932 5.9236 446.694 14.7186 446.074C67.4333 442.245 118.215 424.627 161.974 394.984C205.733 365.342 240.931 324.718 264.04 277.184C309.355 183.593 304.917 69.057 242.405 -23.2261C215.285 -63.3247 178.886 -96.2847 136.302 -119.306C93.7182 -142.328 46.2065 -154.73 -2.19667 -155.461L0.16182 -306.022C18.0342 -305.733 35.8737 -304.382 53.5856 -301.975C176.476 -285.335 292.041 -218.431 367.068 -107.673C442.095 3.08453 461.355 135.213 431.23 255.517C404.352 363.357 338.523 457.439 246.421 519.642Z" fill="url(#paint0_linear_512_12427)" />
		<defs>
			<linearGradient id="paint0_linear_512_12427" x1="370.978" y1="201.042" x2="192.666" y2="386.648" gradientUnits="userSpaceOnUse">
				<stop stopColor="#152637" stopOpacity="0" />
				<stop offset="1" stopColor="#152637" />
			</linearGradient>
		</defs>
	</svg>

));

// eslint-disable-next-line react/display-name
const DefaultSVG = React.memo(({ svgsRef }) => (
	<svg
		ref={svgsRef}
		width="433"
		height="600"
		viewBox="0 0 433 600"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={'svg-rotate'}>
		<path
			opacity="0.2"
			d="M237.159 519.435C160.872 572.192 70.1381 600.07 -22.6108 599.247L-21.479 448.677C-12.7042 448.75 -3.92196 448.44 4.86776 447.749C57.5496 443.493 108.187 425.463 151.704 395.467C195.221 365.471 230.088 324.562 252.81 276.842C297.365 182.887 291.998 68.3906 228.739 -23.3823C201.295 -63.2596 164.63 -95.9232 121.861 -118.599C79.0915 -141.274 31.4807 -153.291 -16.9268 -153.628L-15.7897 -304.204C2.08443 -304.06 19.9342 -302.853 37.6651 -300.59C160.686 -284.948 276.791 -218.983 352.714 -108.838C428.637 1.3075 448.967 133.275 419.82 253.82C393.818 361.875 328.754 456.487 237.159 519.435Z"
			fill="url(#paint0_linear_506_1014)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_506_1014"
				x1="359.128"
				y1="199.836"
				x2="182.327"
				y2="386.882"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>
));

const LeftSVGScroll = ({ about, footer, product, career }) => {
	const containerRef = useRef(null);
	const scroll = useShowSetting();

	// useEffect(() => {
	// 	if (!scroll?.scrollInstance) return;
	//
	// 	// Kill any existing ScrollTrigger instances first
	// 	ScrollTrigger.getAll().forEach(st => st.kill());
	//
	// 	const svgs = document?.querySelectorAll('.fixed-left');
	// 	const animations = [];
	//
	// 	svgs.forEach((svg, index) => {
	// 		// Create the animation
	// 		const animation = gsap.to(svg, {
	// 			rotation: 90,
	// 			ease: 'power1.out',
	// 			scrollTrigger: {
	// 				id: `svg-rotate-trigger-${index}`,
	// 				trigger: svg,
	// 				start: 'top bottom',
	// 				end: 'bottom top',
	// 				scrub: 0.2,
	// 				markers: false, // set to true for debugging
	// 				invalidateOnRefresh: true, // Recalculate on refresh
	// 				scroller: scroll?.scrollInstance?.el, // Using Locomotive Scroll's scroll element
	//
	// 			}
	// 		});
	// 		animations.push(animation);
	// 	});
	//
	// 	// Cleanup function
	// 	return () => {
	// 		animations.forEach(anim => {
	// 			if (anim.scrollTrigger) {
	// 				anim.scrollTrigger.kill();
	// 			}
	// 			scroll.scrollInstance.update()
	// 			anim.kill();
	// 		});
	// 	};
	// }, [scroll?.scrollInstance]);

	// Memoize the SVG selection logic
	const currentSVG = useMemo(() => {
		if (about) return <AboutSVG  />;
		if (footer) return <FooterSVG  />;
		if (product) return <ProductSVG  />;
		if (career) return <CareerSVG  />;
		return <DefaultSVG />;
	}, [about, footer, product, career]);

	return (
		<div className={`${'fixed-left'}`} ref={containerRef} data-scroll data-scroll-repeat>
			{currentSVG}
		</div>
	);
};

export default LeftSVGScroll;
